import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { format } from '../../util/stringFormatter.js';
import { Box } from '../Box/Box.js';
import { useDirectionContext, Direction } from '../../contexts/session/Locale.js';
import { PageControlIndicator } from './PageControlIndicator.js';

var _excluded = ["pages", "current", "size", "color", "onClick", "accessibilityPageNumberLabel", "indicatorAttributes"];
var scales = {
  m: [100, 83.3, 66.7, 0],
  s: [100, 66.7, 33.3, 0]
};

/** Dotted page control component. */
var PageControl = function PageControl(_ref) {
  var pages = _ref.pages,
    propCurrent = _ref.current,
    _ref$size = _ref.size,
    propSize = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'default' : _ref$color,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? undefined : _ref$onClick,
    accessibilityPageNumberLabel = _ref.accessibilityPageNumberLabel,
    indicatorAttributes = _ref.indicatorAttributes,
    rest = _objectWithoutProperties(_ref, _excluded);
  var direction = useDirectionContext();
  if (pages === 0) return null;
  var isRtl = direction === Direction.RTL;
  var sizePx = propSize === 's' ? '8px' : '12px';
  var dots = [];
  var size = propSize;
  var currentRaw = Math.min(Math.max(propCurrent, 0), pages - 1);
  var current = isRtl ? pages - 1 - currentRaw : currentRaw;
  var start = Math.min(current - 3, Math.abs(pages - 5));
  var end = Math.max(current + 3, 4);
  var half = Math.min(pages, 5) / 2;
  var offsetX = half % 1 + Math.max(Math.floor(half) - current, 0) - Math.max(current - (pages - Math.ceil(half)), 0);
  for (var i = start; i <= end; i += 1) {
    var _indicatorAttributes;
    if (i < 0 || i >= pages) continue;
    var scale = 0;
    if (pages > 5) {
      scale = Math.min(Math.max(Math.abs(i - current), 0), scales[size].length - 1); // Scale by distance from current
      scale = current < 3 ? 3 - Math.max(5 - i, 0) : scale; // Full size before if seeing the start
      scale = current > pages - 4 ? 3 - Math.max(i - (pages - 6), 0) : scale; // Full size after if seeing the end
      scale = Math.min(Math.max(scale, 0), scales[size].length - 1); // Clamp the value to valid scales
    }
    var translate = (i - current - offsetX + 0.5) * 100;
    var realIndex = isRtl ? pages - i - 1 : i;
    var label = accessibilityPageNumberLabel ? format(accessibilityPageNumberLabel, realIndex + 1) : undefined;
    var dotScale = scales[size][scale] / 100;
    if (dotScale === 0) continue;
    var additionalAttributes = (_indicatorAttributes = indicatorAttributes === null || indicatorAttributes === void 0 ? void 0 : indicatorAttributes(realIndex)) !== null && _indicatorAttributes !== void 0 ? _indicatorAttributes : {};
    dots.push(/*#__PURE__*/React.createElement(PageControlIndicator, _extends({
      key: i,
      color: color,
      page: realIndex,
      current: i === current,
      sizePx: sizePx,
      scale: dotScale,
      translation: translate,
      label: label,
      disableClick: size === 's',
      onClick: size === 'm' ? onClick : undefined
    }, additionalAttributes)));
  }
  return /*#__PURE__*/React.createElement(Box, _extends({
    position: "relative",
    pb: "16",
    display: "flex",
    justifyContent: "center"
  }, rest), dots);
};
PageControl.displayName = 'PageControl';

export { PageControl };
//# sourceMappingURL=PageControl.js.map
